<template>
  <div>
    <v-card
      class="mx-auto"
      max-width="666"
      outlined
      v-if="QType.CHOICE.itemType == QuestM.questItemType"
    >
      <v-card-title>
        <v-icon large left> mdi-checkbox-marked-outline </v-icon>
        <span>{{ QType.CHOICE.text }}</span>
      </v-card-title>
      <v-list-item-content>
        <chartPie :QuestM="QuestM" :QuestD="QuestD" />
        <chartBar :QuestM="QuestM" :QuestD="QuestD" />
      </v-list-item-content>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="666"
      outlined
      v-else-if="QType.CHOICE_MULTIPLE.itemType == QuestM.questItemType"
    >
      <v-card-title>
        <v-icon large left> mdi-check-all </v-icon>
        <span>{{ QType.CHOICE_MULTIPLE.text }}</span>
      </v-card-title>
      <v-list-item-content>
        <chartBar :QuestM="QuestM" :QuestD="QuestD" />
      </v-list-item-content>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="666"
      outlined
      v-else-if="QType.RATING.itemType == QuestM.questItemType"
    >
      <v-card-title>
        <v-icon large left> mdi-star </v-icon>
        <span>{{ QType.RATING.text }}</span>
      </v-card-title>
      <v-list-item-content>
        <chartBar :QuestM="QuestM" :QuestD="QuestD" />
      </v-list-item-content>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="666"
      outlined
      v-else-if="QType.NUMERIC.itemType == QuestM.questItemType"
    >
      <v-card-title>
        <v-icon large left> mdi-numeric </v-icon>
        <span>{{ QType.NUMERIC.text }}</span>
      </v-card-title>
      <v-list-item-content>
        <chartBellCurve :QuestM="QuestM" :QuestD="QuestD" />
      </v-list-item-content>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="666"
      outlined
      v-else-if="QType.SLIDER.itemType == QuestM.questItemType"
    >
      <v-card-title>
        <v-icon large left> mdi-ray-vertex </v-icon>
        <span>{{ QType.SLIDER.text }}</span>
      </v-card-title>
      <v-list-item-content>
        <chartBellCurve :QuestM="QuestM" :QuestD="QuestD" />
      </v-list-item-content>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="666"
      outlined
      v-else-if="
        QType.MATRIX.itemType == QuestM.questItemType && QuestM.arraySerial == '0'
      "
    >
      <v-card-title>
        <v-icon large left> mdi-table-large </v-icon>
        <span>{{ QType.MATRIX.text }}－{{ QuestM.cnName }}</span>
      </v-card-title>
      <v-list-item-content>
        <chartRadar :QuestM="QuestM" :QuestD="QuestD" />
      </v-list-item-content>
    </v-card>

    <v-card
      class="mx-auto"
      max-width="666"
      outlined
      v-else-if="QType.MATRIX.itemType == QuestM.questItemType && QuestM.arraySerial != 0"
    >
      <v-card-title>
        <v-icon large left> mdi-table-large </v-icon>
        <span>{{ QType.MATRIX.text }}－{{ QuestM.cnName }}</span>
      </v-card-title>
      <v-list-item-content>
        <chartPie :QuestM="QuestM" :QuestD="QuestD" />
        <chartBar :QuestM="QuestM" :QuestD="QuestD" />
      </v-list-item-content>
    </v-card>

    <div v-else>未知題型</div>
  </div>
</template>
<script>
import ChartBellCurve from '../components/ChartBellCurve'
import ChartPie from '../components/ChartPie'
import ChartBar from '../components/ChartBar'
import ChartRadar from '../components/ChartRadar'

export default {
  components: {
    chartPie: ChartPie,
    chartBellCurve: ChartBellCurve,
    chartBar: ChartBar,
    chartRadar: ChartRadar,
  },
  props: {
    QuestM: {
      type: Object,
      default: () => {},
    },
    QuestD: {
      type: Array,
      default: () => {},
    },
  },
  computed: {
    QType() {
      //return this.$store.state.QType
      // window.console.log(this.$store.state.QType)
      return this.$store.state.QType
    },
  },
  methods: {
    showQues(qtype) {
      //window.console.log(qtype.itemType)
      /*
      if(this.QuestM.questItemType === qtype.itemType){
       window.console.log(123)
      }*/
      //return this.QuestM.questItemType === qtype.itemType//qtype.name
      return qtype.itemType
    },
  },
  mounted() {
    
  },
}
</script>
